<p-date-picker
  class="date-range-picker full-width-inputtext"
  [class.db-date-picker-lighter-border]="variant === 'lighter-border'"
  [class.icon-in-container]="iconInContainer"
  [class.db-datepicker-lg]="size === 'large'"
  [inputStyleClass]="size === 'large' ? 'db-datepicker-input-lg' : ''"
  [showIcon]="true"
  [ngModel]="dateRange"
  selectionMode="range"
  [readonlyInput]="true"
  icon="d-calendar-icon"
  [size]="$any(size === 'large' ? 'large' : null)"
  (ngModelChange)="dateRangeChangedHandler($event)"
  [placeholder]="placeholder"
  [showButtonBar]="showButtonBar"
  [showClear]="showClear"
  (onClear)="onClear.emit()"
  [minDate]="minDate"
  [maxDate]="maxDate"
  [appendTo]="appendTo"
  [attr.data-testId]="dataTestId"
  [dt]="variant === 'lighter-border' ? lighterBorderVariantDatePicker : undefined"
>
  <ng-content></ng-content>

  <ng-template pTemplate="date" let-date>
    <span [attr.data-testId]="date | exec: calendarDayToShortDateString">
      {{ date.day }}
    </span>
  </ng-template>
</p-date-picker>
